import { useEffect, useState } from 'react';
import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, OutlinedInput, Paper, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close, Refresh, Search, Times } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import FilterListIcon from '@material-ui/icons/FilterList';
import UniDialog from '../../Common/UniDialog';
import { useDispatch, useSelector } from 'react-redux';
import { getBatchFilterDialog, getSelectedBatchIds } from '../../../reducers/uiSlice';
import { handleBatchFilterDialog } from '../../../reducers/uiSlice';
import CheckIcon from '@material-ui/icons/Check';
import { getDriverOrderCount, getOrdersStatusWeight, handleFilterChange, handleFilters } from '../../../actions/mmActions';
import { getUserPreference } from '../../../utilities/common';

const useStyles = makeStyles((theme)=> ({
    container: {
        display: 'flex',
        width: '100%'
    },
    chipGroup: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between'
    },
    filterGroup: {
        paddingTop: 10,
        paddingBottom: 20
    },
    chipGroupWidth: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        height: 100
    }
}))

function DriverSearch(props){
    const {t} = useTranslation('mapManagement');
    const classes = useStyles();
    const dispatch = useDispatch();
    const userPref = getUserPreference();

    const pathCodes = [
        {
            name: 'CUSTOM_RELEASE_DIRECT'
        },
        {
            name: 'PARCEL_SCANNED'
        },
        {
            name: 'GATEWAY_TRANSIT'
        },
        {
            name: 'GATEWAY_TRANSIT_OUT'
        }
    ]
    const weightDef = [
        {
            name: "mini_parcel",
            name_trans: t('mini_parcel'),
            minWeight: 0,
            maxWeight: 3,
            short_name: 'XS'
        }, {
            name: "small_parcel",
            name_trans: t('small_parcel'),
            minWeight: 3,
            maxWeight: 5,
            short_name: 'S'
        }, {
            name: "medium_parcel",
            name_trans: t('medium_parcel'),
            minWeight: 5,
            maxWeight: 10,
            short_name: 'M'
        }, {
            name: "large_parcel",
            name_trans: t('large_parcel'),
            minWeight: 10,
            maxWeight: Number.MAX_SAFE_INTEGER,
            short_name: 'L'
        }
    ]

    let openBatchFilterDialog = useSelector(getBatchFilterDialog);
    let selectedBatchIds = useSelector(getSelectedBatchIds);
    const filterChange = useSelector(state => state.mapManagement.filterChange);

    const [searchKeyword, setSearchKeyword] = useState("");
    // Representing XS, S, M, L
    const [weightFilterArr, setWeightFilterArr] = useState([false, false, false, false]); 
    // Representing 198, 200, 199, 195
    const [statusFilterArr, setStatusFilterArr] = useState([false, false, false, false]);
    const [disabledFilter, setDisabledFilter] = useState(true);
    const [placeHolder, setPlaceHolder] = useState('');
    const [filterExist, setFilterExist] = useState(false);

    function placeHolderModify() {
        let holder = ''
        if(weightFilterArr) {
            if(weightFilterArr.length > 0) {
                weightFilterArr.map((filter, index) => {
                    if(filter) {
                        holder += '/' + weightDef[index].name;
                    }
                })
            }
        }
        if(statusFilterArr) {
            if(statusFilterArr.length > 0) {
                statusFilterArr.map((filter, index) => {
                    if(filter) {
                        holder += '/' + pathCodes[index].name;
                    }
                })
            }
        }
        if(holder) {
            holder = holder.substring(1);
        }
        setPlaceHolder(holder);
    }
    function handleClick(index, type) {
        props.handleReset(false);
        let filterArrCopy = [];
        let filterArr = [];
        if(type === 'weight') {
            filterArr = weightFilterArr;
        } else if(type === 'status') {
            filterArr = statusFilterArr;
        }
        filterArr.map((filter, i) => {
            filterArrCopy.push(i === index ? !filter : filter);
        })
        if(type === 'weight') {
            setWeightFilterArr(filterArrCopy);
        } else if(type === 'status') {
            setStatusFilterArr(filterArrCopy);
        }
        return filterArrCopy;
    }
    function handleReset() {
        setWeightFilterArr([false, false, false, false]);
        setStatusFilterArr([false, false, false, false]);
        props.handleReset(true);
        handleClose();
        setPlaceHolder('');
    }
    function handleClose() {
        dispatch(handleBatchFilterDialog({open: false}));
    }
    function concatFilter(type, filter) {
        let filterStr = [];
        if(filter.length > 0) {
            filter.map((condition, index) => {
                if(condition) {
                    if(type === 'weight') {
                        filterStr.push(weightDef[index].short_name);
                    } else if(type === 'status') {
                        filterStr.push(pathCodes[index].name);
                    }
                }
            })
        }
        return filterStr;
    }
    function handleFilter(type, filter, index) {
        let branch = userPref.userCity;
        let weightFilter = concatFilter('weight', weightFilterArr);
        let statusFilter = concatFilter('status', statusFilterArr);

        if(type === 'weight') {
            weightFilter = concatFilter('weight', handleClick(index, type));
        } else if(type === 'status') {
            statusFilter = concatFilter('status', handleClick(index, type));
        }
        
        if(statusFilter.length === 0 && weightFilter.length === 0) {
            dispatch(getDriverOrderCount(branch, selectedBatchIds))
        } else {
            let params = {};
            params['branch'] = branch;
            params['batch_list'] = selectedBatchIds.toString();
            params['hide_associated'] = 1;
            params['hide_sub_referrer'] = 0;
            if(statusFilter.length > 0) {
                params['status'] = statusFilter.toString();
            }
            if(weightFilter.length > 0) {
                params['weight'] = weightFilter.toString();
            }
            dispatch(getOrdersStatusWeight(params))
        }
        if(type === 'weight') {
            dispatch(handleFilterChange(filterChange, {parcelWeight: filter}));
        } else {
            dispatch(handleFilterChange(filterChange, {parcelStatus: filter}));
        }
    }
 
    useEffect(() => {
        if(weightFilterArr || statusFilterArr) {
            placeHolderModify();
            let exist = false;
            if(weightFilterArr.length > 0) {
                weightFilterArr.map((filter) => {
                    exist = exist || filter;
                })
            }
            if(statusFilterArr.length > 0) {
                statusFilterArr.map((filter) => {
                    exist = exist || filter;
                })
            }
            setFilterExist(exist);
            props.handleWeightFilterTotal(exist);
        }
    }, [weightFilterArr, statusFilterArr])
    useEffect(() => {
        if(openBatchFilterDialog) {
            props.handleReset(false);
        }
    }, [openBatchFilterDialog])
    useEffect(() => {
        if(selectedBatchIds) {
            if(selectedBatchIds.length > 0) {
                setDisabledFilter(false);
            } else {
                setDisabledFilter(true);
            }
        } else {
            setDisabledFilter(true);
        }
    }, [selectedBatchIds])

    return (
        <div className={classes.container}>
            <OutlinedInput
                name="search-driver"
                autoComplete='off'
                startAdornment={
                    <InputAdornment position='start'>
                        <Search />
                    </InputAdornment>
                }
                endAdornment={
                    <InputAdornment position='end'>
                        {
                            searchKeyword.length > 0 ? 
                            <IconButton
                                aria-label="toggle-visibility"
                                size='small'
                                onClick={clearInput}
                            >
                                <Close color='error'/>
                            </IconButton>
                            :
                            <div></div>
                        }
                    </InputAdornment>
                }
                fullWidth
                size='small'
                placeholder={placeHolder || t('common:search')}
                value={searchKeyword}
                onChange={_handleSearchChange}
            />
            <IconButton
                color={filterExist?'primary':'none'} 
                style={{marginLeft: 16}}
                onClick={()=>dispatch(handleBatchFilterDialog({open: true}))}
                disabled={disabledFilter}
            >
                <FilterListIcon/>
            </IconButton>
            <IconButton 
                aria-label="refresh" 
                color='primary' 
                style={{marginLeft: 16}}
                onClick={
                    props.onRefreshClicked
                }
            >
                <Refresh />
            </IconButton>
            <Dialog
                fullWidth
                maxWidth='sm'
                open={openBatchFilterDialog}
            >
                <DialogTitle>
                    {t("dialog:order_filter_title")}
                </DialogTitle>
                <DialogContent>
                    <div className={classes.filterGroup}>
                        <div style={{marginBottom: 20}}>{t('filter_by_tracking_status')}</div>
                        <div className={classes.chipGroupWidth}>
                            {
                                pathCodes.map((code, index) => (
                                    <Chip
                                        key={index}
                                        color={statusFilterArr[index] ?  "secondary" : "default"}
                                        clickable
                                        icon={statusFilterArr[index] ? <CheckIcon />: null}
                                        label={code.name}
                                        onClick={() => {
                                            handleFilter('status', code.name, index);
                                        }}
                                    />
                                ))
                            }
                        </div>
                    </div>
                    <div className={classes.filterGroup} style={{marginTop: 20}}>
                        <div style={{marginBottom: 20}}>
                            {t('filter_by_weight')}
                        </div>
                        <div className={classes.chipGroup}>
                        {
                            weightDef.map((weight, index) => (
                                <Chip 
                                    key={index}
                                    color={weightFilterArr[index] ?  "secondary" : "default"}
                                    clickable
                                    icon={weightFilterArr[index] ? <CheckIcon />: null}
                                    label={weight.name_trans}
                                    onClick={() => {
                                        handleFilter('weight', weight, index);
                                    }}
                                />
                            ))
                        }
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <div style={{marginBottom: 27, marginTop: 40, marginRight: 20}}>
                        <Button onClick={handleReset}>
                            {t('clear_filters')}
                        </Button>
                        <Button 
                            onClick={handleClose}
                            variant='contained'
                            color='primary'
                            style={{marginLeft: 62}}
                        >
                            {t('search')}
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    )

    function _handleSearchChange(event){
        setSearchKeyword(event.target.value)
        props.onKeywordChange(event.target.value)
    }

    function clearInput(){
        setSearchKeyword("")
        props.onKeywordChange("")
    }
}

DriverSearch.defaultProps = {
    handleReset: ()=>{},
    handleWeightFilterTotal: ()=>{},
    onRefreshClicked: ()=>{},
    onKeywordChange: ()=>{}
}

export default DriverSearch;